<template>
  <div class="permission-create">
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-alert v-model="hasError" variant="warning">
      {{ errorMessage }}
    </b-alert>

    <b-alert v-model="isSucceded" variant="success">
      Die Person wurde eingeladen und erhält in Kürze eine Einladung.
    </b-alert>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit)" inline>

        <validation-provider vid="email" rules="required|email" v-slot="{ valid, errors, changed }">
          <b-form-group id="input-group-email" label-for="input-email">
            <b-form-input
              v-model="form.email"
              :state="onValidateField(valid, errors, changed)"
              type="email"
              placeholder="E-Mail angeben"
            ></b-form-input>
            <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="primary" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Einladen
        </b-button>
        <b-button type="submit" variant="primary" v-else>Einladen</b-button>
      </b-form>
    </validation-observer>

  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'

  const getInitialData = () => ({
    form: {
      email: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('permission/CREATE_PERMISSION', {
          formData: this.form,
          applicationId: this.applicationId
        }).then(res => {
          const { errors } = res

          if (errors) {
            if (errors[0].extensions && errors[0].extensions.code === 'EMAIL_HAS_ALREADY_ACCESS') {
              this.hasError = true
              this.errorMessage = 'Diese E-Mailadresse hat bereits Zugang zu diesem Gesuch'
              this.isSubmitting = false
              return
            }
          }

          this.isSucceded = true
          this.isSubmitting = false
          this.reset()
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          this.scrollTo()
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    props: {
      applicationId: {
        type: Number,
        required: true
      }
    },
    watch: {
      applicationId (newValue, oldValue) {
        if (newValue !== oldValue) {
          Object.assign(this.$data, this.$options.data())
        }
      }
    }
  }
</script>

<style lang="scss">
  .permission-create{
    .form-inline{
      margin: 2rem 0 3rem;
      align-items: flex-start;

      > span{
        width: 70%;

        @include media-breakpoint-down(sm) {
          width: 100%;
        }

        .bv-no-focus-ring{
          width: 100%;

          .form-control{
            width: 95%;

            @include media-breakpoint-down(sm) {
              width: 100%;
            }
          }

        }
      }
    }

    .btn-primary{
      padding: 8px 0.75rem;
    }
  }
</style>
